/* ONE TUNNE product page custom elements: no framework, no analytics; strings come from data-*
 * attributes and JSON islands Liquid rendered. Events: `variant:changed`, `addons:changed`. */
(() => {
  if (customElements.get('variant-picker')) return;
  const VARIANT = 'variant:changed';
  const ADDONS = 'addons:changed';
  const json = (host) => {
    const node = host.querySelector('[data-map]');
    try { return node ? JSON.parse(node.textContent) || {} : {}; } catch (error) { return {}; }
  };
  const money = (cents, format) => {
    const m = String(format || '').match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return String(format || '');
    const none = m[1].indexOf('no_decimals') > -1;
    const sep = m[1].indexOf('comma_separator') > -1 ? '.' : m[1].indexOf('apostrophe') > -1 ? "'" : ',';
    let out = ((Number(cents) || 0) / 100).toFixed(none ? 0 : 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep);
    if (!none && sep === '.') out = out.replace(/\.(\d\d)$/, ',$1');
    return format.replace(m[0], out);
  };
  const fill = (text, token, value) => String(text || '').split(token).join(value);
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const scope = (node) => (node && node.closest('[data-product-root]')) || document;
  const send = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail }));

  /* The variant is always resolved from the CURRENT selection: clicked value + the values
     selected in the other options. Each link's server-rendered variant id is only valid for
     the selection the page loaded with, so following it would reset the other options. */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.map = json(this);
      const first = this.querySelector('[data-variant-link][aria-current="true"]');
      this.start = first ? first.dataset.variantId : Object.keys(this.map)[0];
      this.current = this.start;
      this.onPop = this.onPop.bind(this);
      this.addEventListener('click', this);
      window.addEventListener('popstate', this.onPop);
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPop); }
    find(values) {
      for (const id in this.map) {
        const o = this.map[id].o || [];
        if (values.every((v, i) => o[i] === v)) return id;
      }
      return null;
    }
    handleEvent(e) {
      const a = e.target.closest('[data-variant-link]');
      if (!a) return;
      e.preventDefault();
      const row = a.closest('[data-option-row]');
      const wanted = ((this.map[this.current] || {}).o || []).slice();
      wanted[Number(row ? row.dataset.optionRow : 0)] = a.dataset.optionValue;
      const id = this.find(wanted);
      if (!id) { window.location.href = a.href; return; }
      this.select(id, true);
    }
    onPop() {
      const id = new URLSearchParams(window.location.search).get('variant') || this.start;
      if (this.map[id]) this.select(id, false);
    }
    select(id, push) {
      const entry = this.map[String(id)];
      if (!entry) return;
      const same = this.current === String(id);
      this.current = String(id);
      const target = new URL(window.location.href);
      target.searchParams.set('variant', id);
      const url = target.pathname + target.search;
      if (push && !same) {
        try { window.history.pushState({ variant: id }, '', url); } catch (error) {}
      }
      const values = entry.o || [];
      this.querySelectorAll('[data-option-row]').forEach((row) => {
        const index = Number(row.dataset.optionRow);
        const label = row.querySelector('[data-option-value]');
        if (label && values[index]) label.textContent = values[index];
        row.querySelectorAll('[data-variant-link]').forEach((a) => {
          const candidate = values.slice();
          candidate[index] = a.dataset.optionValue;
          const match = this.find(candidate);
          a.setAttribute('aria-current', a.dataset.optionValue === values[index] ? 'true' : 'false');
          a.toggleAttribute('data-unavailable', !match || !this.map[match].a);
          if (match) {
            a.dataset.variantId = match;
            a.setAttribute('href', window.location.pathname + '?variant=' + match);
          }
        });
      });
      send(VARIANT, { id: String(id), url: url, mediaId: entry.m ? String(entry.m) : '' });
    }
  }

  class VariantSwap extends HTMLElement {
    connectedCallback() {
      this.map = json(this);
      this.target = this.querySelector('[data-swap]');
      this.onVariant = this.onVariant.bind(this);
      document.addEventListener(VARIANT, this.onVariant);
    }
    disconnectedCallback() { document.removeEventListener(VARIANT, this.onVariant); }
    onVariant(e) {
      if (!this.target) return;
      const value = this.map[e.detail.id];
      if (this.target.dataset.swap === 'html') {
        if (value !== undefined) this.target.innerHTML = value;
        return;
      }
      this.target.textContent = value || '';
      this.hidden = !value;
    }
  }

  class FitmentPanel extends HTMLElement {
    connectedCallback() {
      this.onGarage = this.onGarage.bind(this);
      this.text = this.querySelector('[data-fit-text]');
      this.note = this.querySelector('[data-fit-note]');
      document.addEventListener('garage:changed', this.onGarage);
      // The garage only broadcasts on change: read the saved model once on load as well.
      customElements.whenDefined('garage-store').then(() => {
        const S = customElements.get('garage-store');
        if (S && S.get) this.onGarage({ detail: S.get() || {} });
      });
    }
    disconnectedCallback() { document.removeEventListener('garage:changed', this.onGarage); }
    onGarage(e) {
      const d = e.detail || {};
      const fits = this.getAttribute('data-fits') || '';
      const match = d.slug && (' ' + fits + ' ').indexOf(' ' + d.slug + ' ') > -1;
      if (!d.slug || !fits) {
        this.setAttribute('data-fit-state', 'unknown');
        if (this.text) this.text.textContent = this.getAttribute('data-label-default') || '';
        if (this.note) this.note.hidden = true;
        return;
      }
      this.setAttribute('data-fit-state', match ? 'fit' : 'nofit');
      const label = this.getAttribute(match ? 'data-label-fits' : 'data-label-not');
      if (this.text) this.text.textContent = fill(label, '{model}', d.name || d.slug);
      if (this.note) this.note.hidden = false;
    }
  }

  class ProductAddons extends HTMLElement {
    connectedCallback() { this.addEventListener('change', this); this.publish(); }
    handleEvent() { this.publish(); }
    items() {
      const picked = [];
      this.querySelectorAll('[data-addon-input]:checked').forEach((input) => {
        const id = Number(input.value);
        if (id) picked.push({ id: id, quantity: 1, cents: Number(input.dataset.price) || 0 });
      });
      return picked;
    }
    publish() { send(ADDONS, { cents: this.items().reduce((a, i) => a + i.cents, 0) }); }
  }

  const addons = (n) => Array.from(scope(n).querySelectorAll('product-addons'));
  const addonItems = (n) => addons(n).reduce((a, h) => a.concat(h.items().map((i) => ({ id: i.id, quantity: 1 }))), []);
  const addonCents = (n) => addons(n).reduce((a, h) => a + h.items().reduce((b, i) => b + i.cents, 0), 0);

  /* Spinner (.btn--loading) + aria-busy; the drawer path does the same in cart.js. */
  const busy = (node, on) => {
    if (!node || !node.classList) return;
    node.classList.toggle('btn--loading', !!on);
    if (on) node.setAttribute('aria-busy', 'true');
    else node.removeAttribute('aria-busy');
    if ('disabled' in node) node.disabled = !!on;
  };

  const addToCart = async (items, trigger) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.dataset.cartType === 'drawer') return drawer.addItems(items, trigger);
    const routes = window.Shopify && window.Shopify.routes;
    busy(trigger, true);
    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!response.ok) throw new Error('add');
      window.location.href = (routes && routes.cart_url) || root() + 'cart';
    } catch (error) {
      busy(trigger, false);
      const box = scope(trigger).querySelector('[data-cart-error]');
      if (!box) return;
      box.textContent = box.dataset.errorGeneric || '';
      box.hidden = false;
    }
  };

  class CartControl extends HTMLElement {
    connectedCallback() {
      this.map = json(this);
      this.input = this.querySelector('[data-variant-input]');
      this.button = this.querySelector('[data-add-button]');
      this.quantity = this.querySelector('[data-quantity-input]');
      this.label = this.querySelector('[data-add-label]');
      this.price = this.querySelector('[data-sticky-price]');
      this.meta = this.querySelector('[data-sticky-meta]');
      this.onVariant = this.onVariant.bind(this);
      this.onAddons = this.onAddons.bind(this);
      this.addEventListener('click', this);
      this.addEventListener('submit', this);
      this.addEventListener('input', this);
      document.addEventListener(VARIANT, this.onVariant);
      document.addEventListener(ADDONS, this.onAddons);
      if (this.hasAttribute('data-sticky')) this.watch();
      this.render();
    }
    disconnectedCallback() {
      document.removeEventListener(VARIANT, this.onVariant);
      document.removeEventListener(ADDONS, this.onAddons);
      if (this.observer) this.observer.disconnect();
    }
    watch() {
      const target = document.querySelector('[data-main-atc]');
      if (!target || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([box]) => {
        this.toggleAttribute('data-shown', !box.isIntersecting && box.boundingClientRect.top < 0);
      });
      this.observer.observe(target);
    }
    count() { return Math.max(1, parseInt(this.quantity && this.quantity.value, 10) || 1); }
    handleEvent(event) {
      if (event.type === 'input') { this.render(); return; }
      const id = Number(this.input && this.input.value);
      if (event.type === 'submit' || event.target.closest('[data-add-button]')) {
        if (!id) return;
        event.preventDefault();
        // render() afterwards restores the sold-out state if the variant changed mid-request.
        Promise.resolve(addToCart([{ id: id, quantity: this.count() }].concat(addonItems(this)), this.button))
          .then(() => this.render());
        return;
      }
      const step = event.target.closest('[data-quantity-step]');
      if (!step || !this.quantity) return;
      event.preventDefault();
      this.quantity.value = Math.max(1, this.count() + Number(step.dataset.quantityStep));
      this.render();
    }
    onVariant(e) {
      if (this.input) this.input.value = e.detail.id;
      this.render();
    }
    onAddons() { this.render(); }
    render() {
      const variant = this.map[String(this.input && this.input.value)];
      const available = variant ? variant.a : true;
      const cents = (variant ? variant.p : 0) * this.count() + addonCents(this);
      const total = money(cents, this.getAttribute('data-money-format'));
      if (this.button) this.button.disabled = !available;
      if (this.meta && variant && variant.t) this.meta.textContent = variant.t;
      if (this.price) this.price.textContent = total;
      if (!this.label) return;
      this.label.textContent = available
        ? fill(this.getAttribute('data-label-add'), '{total}', total)
        : this.getAttribute('data-label-sold-out') || '';
    }
  }

  const define = (n, e) => { if (!customElements.get(n)) customElements.define(n, e); };
  define('variant-picker', VariantPicker);
  define('product-price', VariantSwap);
  define('stock-scarcity', class extends VariantSwap {});
  define('fitment-panel', FitmentPanel);
  define('product-addons', ProductAddons);
  define('buy-buttons', CartControl);
  define('sticky-atc', class extends CartControl {});
})();
